module.exports = __webpack_public_path__ + "img/dentinho-ajuda-testev2.702cfe39.png";